<template>
  <PageTemplate>
    <template v-slot:page-content>
      <div id="paypoint-terms-and-conditions-page">
        <b-container fluid id="page-container">
          <div id="content-container-with-border">
            <h1>Terms and Conditions</h1>
            <h2>Legal</h2>
            <p>
              References to "you" or "your" are references to any person
              accessing this website ("site").
            </p>
            <p>
              References to "we", "us" or "our" are references to PayPoint
              Network Limited.
            </p>
            <p>
              References to "PayPoint Group" are references to us, our parent
              company and any companies we or our parent company totally or
              partly own at any time.
            </p>

            <h2>Purpose</h2>
            <p>
              This page (together with the documents referred to on it) tells
              you the terms of use on which you may make use of the PayPoint
              website www.My.PayPoint.com.
            </p>
            <p>
              Please read these terms of use carefully before you start to use
              the website. By using the website, you indicate that you accept
              these terms of use and that you agree to abide by them. If you do
              not agree to these terms of use, please refrain from using the
              My.PayPoint website.
            </p>

            <h2>Operation</h2>
            <p>
              www.My.PayPoint.com is a website operated by PayPoint Network
              Limited ("PayPoint"). PayPoint Network Limited is registered in
              England under company number 02973115 and has its registered
              office at 1 The Boulevard, Shire Park, Welwyn Garden City,
              Hertfordshire AL7 1EL. PayPoint is part of the PayPoint PLC group
              of companies.
            </p>

            <h2>My.PayPoint.Com</h2>
            <p>
              My.PayPoint.com provides you with access to information about the
              services we provide to you and the services you provide to us. It
              enables you to access reports on your store's performance, set up
              new products & promotions, and configure your till configuration
              to manage your operation efficiently.
            </p>

            <h2>Access</h2>
            <p>
              The content of this site includes financial information about your
              business. You are responsible for ensuring you only grant access
              to those you wish to see or review this information. You can limit
              the access rights of individuals by changing the settings by
              visiting User Management in My.PayPoint.com.
            </p>
            <p>
              We reserve the right to modify, suspend or discontinue,
              temporarily or permanently, the site or any part of it, with or
              without notice, at any time. You agree that we shall not be liable
              to you or to any third party for any such modification, suspension
              or discontinuance of the site.
            </p>

            <h2>Registration, Log-in and Security</h2>
            <p>
              If you wish to use the My.PayPoint.com website you must first
              register as a user and be eligible to register (please contact
              PayPoint using the details below for information on eligibility).
              You must provide accurate and complete registration information
              and will need to set up both a Username and a Password in order in
              order to register.
            </p>
            <p>There are two ways to log-in to My.PayPoint.com:</p>
            <h3>Log-in Method 1.</h3>
            <ul>
              <li>
                Using your Site Number (the number assigned to your site
                location by PayPoint and available on your PayPoint
                documentation).
              </li>
              <li>
                A “Username”- when logging in as a Site this will be created for
                you at install, and you can create further users with distinct
                Usernames via the User Management option in My.PayPoint.com.
              </li>
              <li>
                A "Password"- this is a confidential word or number or
                combination used as a code to confirm your identity when
                accessing My.PayPoint. This must be between 8 and 15 characters
                (when logging in using a Site Number). We strongly recommend a
                secure password including a mix of letters, numbers and special
                characters.
              </li>
            </ul>
            <p>
              If you log-in using Log-in Method 1, you will be able to see sales
              and operational information for the specific Site assigned the
              Site Number you used to log-in with, as well as your usual access
              to statements.
            </p>

            <h3>Log-in Method 2.</h3>
            <ul>
              <li>
                Email Address- this is the email address nominated by you at the
                time you register to use My.PayPoint.com, when logging in an as
                an Agent.
              </li>
              <li>
                A "Password"- this is a confidential word or number or
                combination used as a code to confirm your identity when
                accessing My.PayPoint. This must be between 8 and 15 characters
                and (when logging in using an email address) it must also
                include three from: an uppercase or lowercase letter, number and
                special character.
              </li>
            </ul>
            <p>
              If you log-in using Log-in Method 2, you will only have access to
              your statements and data, you will not be able to retrieve sales
              and operational information in relation to a specific Site.
            </p>
            <p>
              PayPoint will use reasonable endeavours to ensure that access to
              My.PayPoint.com is possible at all times, however no warranty or
              guarantee is provided in this respect and PayPoint shall not be
              liable in any way if the website is unavailable.
            </p>
            <p>
              PayPoint may at any time, and without notice, withdraw
              My.PayPoint.com in part or in its entirety, or restrict or prevent
              you from accessing the website if PayPoint has reasonable grounds
              for doing so.
            </p>
            <p>
              PayPoint endeavours to maintain a high level of internet security.
              To maintain such security you must:
            </p>
            <ul>
              <li>
                ensure that both your username and password are kept secure at
                all times;
              </li>
              <li>
                when choosing a password, ensure that it is one that is not
                likely to be anticipated by anyone attempting to access
                My.PayPoint.com pretending to be you. We strongly recommend a
                secure password including a mix of letters, numbers and special
                characters;
              </li>
              <li>
                not disclose your username or password to anyone. PayPoint
                support colleagues, if needed, will able to offer remote support
                without this information;
              </li>
              <li>
                not record your password in any form that identifies it as being
                a password to access My.PayPoint.com;
              </li>
              <li>
                contact PayPoint on the contact details below immediately upon
                discovering or suspecting that your password is being used by or
                is known by any third party;
              </li>
              <li>
                not allow any other person to access your My.PayPoint.com
                account;
              </li>
              <li>
                ensure that nobody can see, copy or access information, or
                obtain your username and/or password when you are using your
                My.PayPoint.com account;
              </li>
              <li>
                not, whilst accessing My.PayPoint.com, leave your computer or
                any similar device used for accessing the website unattended;
              </li>
              <li>
                prior to accessing the service from any computer connected to a
                local area network or LAN, take steps to ensure that no other
                party will be able to see, copy or access information and/or
                obtain your username and/or password;
              </li>
              <li>
                change your password immediately if PayPoint requests that you
                do so; and
              </li>
              <li>
                take all reasonable steps to ensure that the computer or any
                similar device that you are accessing My.PayPoint.com from is
                free from computer viruses. You also agree to take reasonable
                measures to ensure that the computer or other device you are
                using is itself adequately protected against the receipt of
                computer viruses.
              </li>
            </ul>

            <h2>Reporting</h2>
            <p>
              You can access reports detailing your store's sales performance,
              with margin and profit calculations. You can also access Stock
              Reports and view reports showing till events, PayPoint Sales, and
              promotion performance. All reports are subject to the data
              (including but not limited to, stock costs and prices) that you
              have provided in the My.PayPoint.com site and till.
            </p>
            <p>
              <strong>
                It is important to check your reports regularly, especially when
                using these for external reporting or reconciliation purposes.
                PayPoint assumes no any liability for the accuracy of these
                reports.
              </strong>
            </p>

            <h2>Intellectual Property</h2>
            <p>
              You are responsible for obeying all applicable laws relating to
              the intellectual property rights subsisting in this website. The
              information and graphics contained in this website are protected
              by copyright under national laws and international treaties. The
              website may be copied for the purpose of viewing, but may not be
              permanently stored or copied for further distribution. "PayPoint"
              is a trademark of PayPoint Network Limited a subsidiary of
              PayPoint PLC.
            </p>

            <h2>Privacy and Cookies</h2>
            <p>
              For information on how PayPoint uses personal data and cookies,
              please <a href="/PrivacyAndCookies">click here</a>
            </p>

            <h2>Financial Promotions</h2>
            <p>
              The material contained in this website is a guide for general
              information purposes only. This website does not provide or offer
              financial or other advice and its contents should not be relied
              upon as such.
            </p>
            <p>
              This website does not give any advice or make any recommendation
              (and should not be construed as so doing) and should not be relied
              upon. Any and all liability which might arise from your use or
              reliance on the information or links contained on the website is
              excluded. Actual results or developments may be materially
              different from any forecast, opinion or expectation expressed on
              this website and the past performance of the price of securities
              must not be relied upon as a guide to their future performance.
            </p>
            <p>
              Nothing on this website constitutes an invitation or offer to
              enter into any sort of commercial arrangement for the provision of
              goods and service by PayPoint. These terms and conditions of use
              are not PayPoint's terms of business which would be made available
              to a prospective business partner at the appropriate time.
            </p>
            <p>
              Nothing on this website constitutes an invitation or offer to
              invest or deal in the securities of PayPoint.
            </p>

            <h2>Disclaimer</h2>
            <p>
              PayPoint seeks to ensure that the information on this website
              (other than information accessed by hypertext links) is accurate.
              However, no representation or warranty is made and no liability is
              accepted as to the accuracy, completeness or any other aspect of
              the information or links contained on the website. Any and all
              liability which might arise from your use or reliance on the
              information or links contained on the website is excluded unless
              such liability results from fraudulent misrepresentation or is for
              death or personal injury caused by negligence.
            </p>
            <p>
              You are reminded that the internet is an inherently unstable
              medium and the risks of interruption, interference and disruption
              mean that the information or links contained on this website may
              in fact be outside the control of PayPoint. In addition, errors,
              omissions, interruptions and delays of service may occur at any
              time, and PayPoint accepts no obligation or responsibility in
              respect of such events.
            </p>

            <h2>Electronic Links</h2>
            <p>
              Due to the nature of the My.PayPoint site, electronic links to
              this website are prohibited without the consent of PayPoint. You
              may not frame this website without the consent of PayPoint.
              Certain links on this website may lead to third party websites
              and/or assets located on servers maintained by third parties over
              whom PayPoint has no control. PayPoint makes no representation as
              to the accuracy or any other aspect of, and accepts no liability
              of any kind for, the information contained on such websites or in
              such assets or on such servers.
            </p>

            <h2>Legal Compliance</h2>
            <p>
              It is the responsibility of any person accessing this website in
              any jurisdiction to satisfy themselves as to the full observance
              of the laws and regulatory requirements of the relevant
              jurisdiction, including the obtaining of governmental or other
              consents which may be required or observing any other formality or
              restriction that needs to be observed in such jurisdiction. Any
              failure to comply with any formality or failure to observe any
              restriction may constitute a violation of the securities laws of
              any such jurisdiction.
            </p>

            <h2>Updates and Amendments</h2>
            <p>
              PayPoint may revise these terms of use at any time by amending
              this page. You are expected to check this page from time to time
              to take notice of any changes PayPoint makes, as they are binding
              on you. Some of the provisions contained in these terms of use may
              also be superseded by provisions or notices published elsewhere on
              the website.
            </p>

            <h2>Legal Information</h2>
            <p>
              PayPoint Network Limited is a limited company (Company
              Registration Number 02973115) whose registered office is at 1 The
              Boulevard, Shire Park, Welwyn Garden City, Hertfordshire, England,
              AL7 1EL.
            </p>
            <p>
              For additional contact information please email:
              <a href="mailto:contactus@paypoint.com">contactus@paypoint.com</a>
            </p>

            <h2>Terms of Business</h2>
            <p>
              For the Terms of Business applicable to each of the PayPoint
              Services please see the information provided on the appropriate
              Service website.
            </p>

            <h2>Contact</h2>
            <p>
              If you have any concerns about material which appears on
              PayPoint's website, please email:
              <a href="mailto:contactus@paypoint.com">contactus@paypoint.com</a>
              or call us on 0330 400 0000
            </p>

            <h2>Governing law</h2>
            <p>
              English law governs these terms and conditions and you agree that
              the English Courts shall have exclusive jurisdiction to determine
              any matter or dispute in connection with or arising out of this
              site and these terms and conditions.
            </p>
            <p>
              This site is designed for use in the UK and is not directed to,
              nor intended for distribution or use by, any person or entity in
              any jurisdiction or country where the publication or availability
              of this site or such distribution or use would be contrary to
              local law or regulation. If you choose to access information on
              this site, it is your responsibility to comply with the applicable
              local, national or international laws and any use of this site
              outside the UK is entirely at your own risk. For guidance relating
              to your specific situation, please contact your legal adviser.
            </p>
          </div>
        </b-container>
      </div>
    </template>
  </PageTemplate>
</template>

<script>
import PageTemplate from "Components/PageTemplate";
import { setPageTitle } from "Utils/pageTitle.js";

export default {
  name: "TermsAndConditions",
  components: {
    PageTemplate,
  },
  created () {
    setPageTitle('Terms and Conditions');
  },
  data() {
    return {
      data: null,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "Design/_variables.scss";
@import "Design/paypoint-form-common-styles.scss";

#paypoint-terms-and-conditions-page {
  background-color: $color-brand-light-blue-grey;
  position: relative;
  height: 100%;
}
</style>
